import { useMemo } from "react";
import { useLocation } from "react-router-dom";
// https://v5.reactrouter.com/web/example/query-parameters
export default function useQuery() {
    var search = useLocation().search;
    return useMemo(function () { return new URLSearchParams(search); }, [search]);
}
